import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito ser ciudadano o residente para aplicar esto?',
    a: 'No. Todo el sistema está diseñado para funcionar perfectamente tanto si tienes SSN (Seguro Social) como si solo tienes ITIN. Te enseñamos los protocolos exactos para ambos casos.'
  }, {
    q: '¿Funciona si mi negocio es nuevo?',
    a: 'Sí, de hecho es el mejor momento. Estructurar tu LLC correctamente desde el día 1 te ahorrará miles de dólares en impuestos y te posicionará para obtener crédito mucho más rápido.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados en el crédito comercial?',
    a: 'Si sigues el paso a paso, puedes empezar a ver aprobaciones iniciales en 30 a 60 días. El crédito es un juego de estructura y paciencia, pero te damos el atajo legal para acelerarlo.'
  }, {
    q: '¿Hay garantía de devolución?',
    a: 'Sí. Tienes 30 días de garantía incondicional. Si aplicas la información y sientes que no vale al menos 10 veces lo que pagaste, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }, {
    q: '¿Qué formato tiene el producto?',
    a: 'Es un producto 100% digital. Inmediatamente después de tu compra, recibirás acceso a la plataforma donde podrás descargar el libro principal en PDF, las plantillas y los bonos.'
  }];
  return <section className="py-14 md:py-20 bg-navy-800 relative overflow-hidden" data-id="element-15">
      {/* Decorative orb */}
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-gold/5 rounded-full blur-3xl" data-id="element-16" />

      <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl text-white mb-4" data-id="element-19">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-20">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-navy/80 border border-white/10 rounded-lg overflow-hidden" data-id="element-21">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" aria-expanded={openIndex === idx} data-id="element-22">
                <span className={`font-heading font-bold pr-4 ${openIndex === idx ? 'text-gold' : 'text-white'}`} data-id="element-23">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180 text-gold' : 'text-gray-500'}`} data-id="element-24" />
              </button>

              <AnimatePresence data-id="element-25">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-26">
                    <div className="px-6 pb-5 text-gray-300 font-body border-t border-white/10 pt-4" data-id="element-27">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}